export default __webpack_public_path__ + "static/media/tuprestamoya.a573455c.jpg";